import { Injectable } from "@angular/core";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { from, Observable, Subject, of, BehaviorSubject } from "rxjs";
import { catchError, timeout, map } from "rxjs/operators";
import { LdsTagsList } from "../../models/LdsTagsList";
import moment from "moment";
import { tokenKey } from "@angular/core/src/view";
import { ApplicationApiProvider } from "../application-api/application-api";
import { Platform } from "ionic-angular";
import { StarmsClientProvider } from "../starms-client/starms-client";
import { LdsTag } from "../../models/trend-live-models/LdsTag";

@Injectable()
export class LdsClientService {
  // private apiBase = `https://sta-rms.siemens-energy.com/api/v4/proxy/lds/`;
  // private webSocketUrl = `wss://sta-rms.siemens-energy.com/api/v4/proxy/ldswebsocket/forward`;

  // private apiBase = `http://localhost:8100/api/v4/proxy/lds/`;
  // private webSocketUrl = `ws://localhost:4201/api/v4/proxy/ldswebsocket/forward`;

  private apiBase;
  private webSocketUrl;

  private socket$: WebSocketSubject<any>;
  private socketId;

  // Emit a true value when the socket connection is established
  public socketReady = new BehaviorSubject<boolean>(false);

  /**
   * Internal stream
   * The access point for all streamed value coming trought the web socket
   */
  stream = new Subject<{
    subscriptionId: string;
    value: {
      responses: Array<{
        tag: string;
        value: number;
        origin: number | string;
      }>;
    };
  }>();

  constructor(
    private http: HttpClient,
    private starms: StarmsClientProvider,
    private appApi: ApplicationApiProvider,
    private platform: Platform
  ) {
    if (this.appApi.isNative()) {
      this.apiBase = `https://sta-rms.siemens-energy.com/api/v4/proxy/lds/`;
      this.webSocketUrl = `wss://sta-rms.siemens-energy.com/api/v4/proxy/ldswebsocket/forward`;
    } else {
      this.apiBase = `http://localhost:8100/api/v4/proxy/lds/`;
      this.webSocketUrl = `ws://localhost:4201/api/v4/proxy/ldswebsocket/forward`;
    }

    if (localStorage.getItem("test_api")) {
      this.apiBase = `https://test.sta-rms.siemens-energy.cloud/api/v4/proxy/lds/`;
      this.webSocketUrl = `wss://test.sta-rms.siemens-energy.cloud/api/v4/proxy/ldswebsocket/forward`;
    }
  }

  /***
   * Set the web socket connection
   * When the connection is established the stream values will be pushed
   * trough the LDS client internal stream
   *
   */
  setUpWebSocket() {
    // cookieMaster.setCookieValue('http://localhost:8100/', 'cookieTEst', 'ha',
    // function() {
    //     console.log('A cookie has been set');
    // },
    // function(error) {
    //     console.log('Error setting cookie: '+error);
    // });
    // If socket is not initialized yet
    if (!this.socket$ || this.socket$.closed) {
      this.socket$ = webSocket({
        url: this.webSocketUrl,
        deserializer: (event) => {
          return event.data;
        },
      });

      // Send the first message to obtain the websocket id
      this.sendMessage("");
    }

    // Receive socket messages
    this.socket$.subscribe((response) => {
      // The first message received will be the socket id
      if (!this.socketId) {
        this.socketId = response;
        this.socketReady.next(true);

        // The further messages will be specific for the active subscriptions
      } else {
        try {
          const jResponse = JSON.parse(response);

          // tslint:disable-next-line: max-line-length

          /**
           * Recieve new values via websocket and emit them internally
           * using the internal stream subject
           */
          this.stream.next({
            subscriptionId: jResponse.subscriptionId,
            value: jResponse,
          });
        } catch (e) {
          console.log(e, response);
        }
      }
    });
  }

  /**
   * Send a message to the websocket
   * @param message message content
   */
  sendMessage(message: any) {
    this.socket$.next(message);
  }

  /**
   * Get all available data sources
   */
  getDataSources() {
    document.cookie = "token=" + localStorage.getItem("token");
    //   return this.starms
    //     .get([this.apiBase + "streaming/api/streaming/sources"])
    //     .pipe(
    //       timeout(10000),
    //       catchError((res) => of([]))
    // );
    return of([]);
  }

  /**
   * Get all tags for a specified data source
   * @param dataSource data source name
   */
  getTagsList(dataSource: string) {
    // return this.starms
    //   .get([this.apiBase + "streaming/api/meta?ds=" + dataSource])
    //   .pipe(
    //     map(
    //       (response: any) =>
    //         new LdsTagsList(response.schema, response.total, response.entries)
    //     )
    //     // catchError(res => of([])),
    //   );
    return of({ entries: [] });
  }

  /**
   * Create a new streaming subscription
   * @param dataSource data source name
   */
  createStreamingSubscription(dataSource: any) {
    let token = localStorage.getItem("token");
    return new Observable<any>((subscriber) => {
      if (!this.socketId) {
        subscriber.error("Socket id not initialized");
        subscriber.complete();
      } else {
        this.http
          .post(
            this.apiBase + "streaming/api/streaming/subscribe",
            {
              socketId: this.socketId,
              clientId: "",
              dataSource: dataSource,
              tagsType: {
                type: "allTagsType",
              },
              batchDurationMs: 1000,
              tagAggregationType: {
                type: "lastValueTagAggregationType",
              },
              sendLastState: true,
            },
            {
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          )
          .subscribe((dsSub) => {
            subscriber.next(dsSub);
            subscriber.complete();
          });
      }
    });
  }

  /**
   * Fetch tags list
   * @param dataSource data source identifier
   * @param tagName tag name
   * @param to interval end
   * @param from interval start
   * @param points number of points
   */
  fetchTags(
    dataSource: any,
    tagName: any,
    to: any,
    fromDate: any,
    points: any
  ) {
    // return from(this.starms.getToken()).mergeMap((token) => {
    //   return this.http.post(
    //     this.apiBase + "history/api/3.0/history/fixed/domain",
    //     {
    //       // body: {
    //       app: dataSource,
    //       tags: [tagName],
    //       domain: {
    //         from: fromDate,
    //         to: to,
    //         points: points,
    //       },
    //     },
    //     {
    //       headers: {
    //         Authorization: "Bearer " + token,
    //       },
    //     }
    //     // }
    //   );
    // });

    return of(new LdsTag());
  }

  /**
   * Stop an active subscription
   * @param subscriptionId subscription identifier
   */
  stopSubscription(subscriptionId: string) {
    // if (subscriptionId !== undefined) {
    //   return from(this.starms.getToken()).mergeMap((token) => {
    //     console.log(subscriptionId);
    //     return this.http.request(
    //       "delete",
    //       this.apiBase + "streaming/api/streaming/unsubscribe",
    //       {
    //         body: { subscriptionId: subscriptionId },
    //         headers: {
    //           Authorization: "Bearer " + token,
    //         },
    //       }
    //     );
    //   });
    // }
    return of([]);
  }

  getTimeZone(dataSource: string, value: number): Observable<any> {
    // return this.starms.get([
    //   this.apiBase + `history/api/3.0/timezone/${dataSource}/${value}`,
    // ]);
    return of([]);
  }

  JsonStringCorrection(input: string) {
    let closedBrackets = 0;
    let openBrackets = 0;

    let i = 0;
    while (i < input.length) {
      if (input[i] == "{") {
        openBrackets++;
      }
      if (input[i] == "}") {
        closedBrackets++;
      }

      if (closedBrackets === openBrackets) {
        break;
      } else {
        i++;
      }
    }
    return input.substring(0, i + 1);
  }
}



// WEBPACK FOOTER //
// ./src/providers/lds-client/lds-client.service.ts